import { render, staticRenderFns } from "./pay_config.vue?vue&type=template&id=6b610544&scoped=true"
import script from "./pay_config.vue?vue&type=script&lang=ts"
export * from "./pay_config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b610544",
  null
  
)

export default component.exports